import StaffPerformanceCSVPreviewBaseColumnsStrategy from './StaffPerformanceCSVPreviewBaseColumnsStrategy'
import StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy from './StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy'

export default function StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy() {}

StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy.prototype = Object.create(StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy.prototype)

StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy.prototype.init = function(includeOtherUsersColumn, groupMessageProvider) {
    StaffPerformanceCSVPreviewOnlyGroupsColumnsStrategy.prototype.init.call(this, includeOtherUsersColumn, groupMessageProvider)
    return this
}

StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy.prototype.addMainHeaderRowCells = function(mainHeaderRow) {
    StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype.addMainHeaderRowCells.call(this, mainHeaderRow)

    let colTitle = this.message("report.common.user")

    this.addCell(mainHeaderRow, this.message("report.subtotal"))
    this.addCell(mainHeaderRow, colTitle)

    if (this.includeOtherUsersColumn) {
        this.addCell(mainHeaderRow, this.message("report.common.others"))
    } else {
        this.addCell(mainHeaderRow, colTitle)
    }
}

StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy.prototype.addColumnGropingHeaderRowCells = function(colGroupingRow) {
    StaffPerformanceCSVPreviewBaseColumnsStrategy.prototype.addColumnGropingHeaderRowCells.call(this, colGroupingRow)
    this.addCell(colGroupingRow, this.message(this.groupMessageProvider.getGroupNameSingularKey()))
    this.addCell(colGroupingRow, this.message(this.groupMessageProvider.getGroupNameSingularKey()))

    if (this.includeOtherUsersColumn) {
        this.addCell(colGroupingRow, "") // above Others
    } else {
        this.addCell(colGroupingRow, this.message(this.groupMessageProvider.getGroupNameSingularKey()))
    }

}

StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy.prototype.getNumOfDataColumns = function() {
    return 4
}



// WEBPACK FOOTER //
// ./web/js/reports/preview/csv/staffperformance/StaffPerformanceCSVPreviewUsersByGroupsWithSubtotalsColumnsStrategy.js